export enum StationType {
    WORKING_AREA = 'WORKING_AREA',
    WAITING_AREA = 'WAITING_AREA'
}
